import axiosInstance from "../api/axiosInstance";
import UserService from "../utils/UserService";

type FileType = "excel" | "pdf";

export const downloadFile = async (
  fileType: FileType,
  sessionId: string,
  onSuccess?: () => void,
  onError?: (error: unknown) => void,
) => {
  const token = UserService.getToken();

  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
    responseType: "blob" as const,
  };

  const apiEndpoint =
    fileType === "excel"
      ? `/downloads/excel/${sessionId}`
      : `/downloads/pdf/${sessionId}`;

  try {
    const response = await axiosInstance.get(apiEndpoint, config);

    const contentDisposition =
      response.headers["content-disposition"] ||
      response.request?.getResponseHeader?.("Content-Disposition");

    let fileName =
      fileType === "excel" ? "classification.xlsx" : "classification.pdf";

    if (contentDisposition?.includes("filename=")) {
      fileName = contentDisposition
        .split("filename=")[1]
        .replace(/"/g, "")
        .trim();
    }

    await downloadBlob(fileName, response.data);

    if (onSuccess) onSuccess();
  } catch (error) {
    console.error(`Erro ao baixar o arquivo ${fileType.toUpperCase()}:`, error);
    if (onError) onError(error);
  }
};

export const downloadBlob = async (filename: string, data: Blob) => {
  const downloadUrl = window.URL.createObjectURL(data);
  const element = document.createElement("a");
  element.href = downloadUrl;
  element.setAttribute("download", filename);
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
  window.URL.revokeObjectURL(downloadUrl);
};

export const downloadFileFromApi = async (
  endpoint: string,
  defaultFileName: string,
) => {
  const token = UserService.getToken();

  const config = {
    headers: { Authorization: `Bearer ${token}` },
    responseType: "blob" as const,
  };

  const response = await axiosInstance.get(endpoint, config);

  const contentDisposition =
    response.headers["content-disposition"] ||
    response.request?.getResponseHeader?.("Content-Disposition");

  let fileName = defaultFileName;

  if (contentDisposition?.includes("filename=")) {
    fileName = contentDisposition
      .split("filename=")[1]
      .replaceAll('"', '')
      .trim();
  }

  await downloadBlob(fileName, response.data);
};

export const handleDownloadError = async (
  error: any,
  setBackgroudError: (value: string) => void,
) => {
  let message = "Erro ao baixar relatório.";

  if (error?.response?.data instanceof Blob) {
    const text = await error.response.data.text();

    try {
      const json = JSON.parse(text);

      if (
        json.message ===
          "No Session Metadata with outputfile valid was found!" ||
        json.message === "No session metadata was found for this period!"
      ) {
        message = "Não há dados disponíveis para essa data!";
        setBackgroudError("#FFDF95");
      } else {
        setBackgroudError("#FFD9D9");
      }
    } catch {
      console.error("Erro ao converter blob para JSON");
    }
  }

  return message;
};
